import { Box, Button, styled } from '@/theme/index';

export const DashboardWelcomeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const VerifiedTag = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  border: '1px solid',
  borderColor: theme.palette.secondary.main,
  borderRadius: theme.spacing(0.5),
  width: 'fit-content',
  padding: theme.spacing(0.5, 1),
}));

export const CustomButton = styled(Button)(({ theme }) => ({
  flex: 'auto',
  fontWeight: '500',
  border: '1px solid',
  borderColor: theme.palette.secondary.main,
  borderRadius: theme.spacing(0.5),
  minWidth: 'fit-content',
  backgroundColor: theme.palette.background.paper,
}));
